
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import DayOfMonthSelector from '@/components/FormComponents/DayOfMonthSelector.vue';
import { ValidationObserver } from 'vee-validate';
import { CommonStore, ConfigurationStore, BlockStore } from '@/store/modules';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import helpers from '@/utils/helpers';
import { SeasonCalendar } from '@/store/models/configuration';

@Component({
  components: {
    ValidationObserver,
    QvInput,
    QvSelect,
    DayOfMonthSelector,
    LocationInputMap
  }
})
export default class SeasonConfigurationForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  cropId: number | null = null;

  season: SeasonCalendar = {} as SeasonCalendar;

  month: number | null = null;
  day: number | null = null;

  startDayOfMonth: {
    month: number;
    day: number;
  } = {
    month: 1,
    day: 1
  };

  get currentFarm() {
    return CommonStore.SelectedFarmBlock;
  }

  get farms() {
    return [
      {
        value: this.currentFarm.farmId,
        label: this.currentFarm.name
      }
    ];
  }

  get farmCrops() {
    return BlockStore.FarmCrops.map(x => {
      return {
        value: x.id,
        label: `${x.cropTypeName} - ${x.varietyName}`
      };
    });
  }

  get farmCropVarieties() {
    const cropVarieties = BlockStore.SeasonCropVarieties;
    if (this.cropId) {
      return cropVarieties
        .filter(x => x.cropType == this.cropId)
        .map(x => {
          return { value: x.id, label: x.name };
        });
    }
    return [];
  }

  startDateVisible = false;
  endDateVisible = false;

  get submitLabel() {
    if (this.season && this.season.id && this.season.id != 0) {
      return 'Update';
    }
    return 'Add';
  }

  async onSubmit() {
    if (this.season.id && this.season.id != 0) {
      await ConfigurationStore.updateSeasonCalendar(this.season);
      this.$q.notify({
        message: 'Updated season successfully',
        type: 'positive'
      });
    } else {
      if (this.cropId) {
        this.season.crop = this.cropId;
      }
      await ConfigurationStore.createSeasonCalendar(this.season);
      this.$q.notify({
        message: 'Added season successfully',
        type: 'positive'
      });
    }
    ConfigurationStore.getSeasonList({ farm: this.currentFarm.farmId });
    this.$router.push({ name: 'SeasonConfiguration' });
  }

  onReset() {
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
      this.$router.push({ name: 'SeasonConfiguration' });
    });
  }

  async loadFarm() {
    BlockStore.getFarmCrops({ farmId: this.currentFarm.farmId });
    BlockStore.getFarmCropVarieties({ farmId: this.currentFarm.farmId });
    if (this.$route.params.seasonId) {
      const seasonId = Number(this.$route.params.seasonId);
      await ConfigurationStore.getSeasonCalendarById(seasonId);
      this.season = ConfigurationStore.AddEditSeasonCalendar;
      this.cropId = this.season.crop;
    } else {
      this.season.farm = this.currentFarm.farmId;
      this.season.startMonth = 4;
      this.season.startDay = 1;
      this.season.endMonth = 3;
      this.season.endDay = 31;
    }
    if (this.$route.params.cropId) {
      this.cropId = Number(this.$route.params.cropId);
    }
  }

  async created() {
    await helpers.fetchingDefaultFarm();
    this.loadFarm();
  }
}
